import React from 'react';
import PropTypes from 'prop-types';
import Overlay from 'components/Overlay';

const MvpdDirectSignInRedirect = ({
  backgroundUrl,
  theme,
  children,
  innerContainerChildren,
  rendered,
  backgroundClass,
  sharedTheme,
}) => (
  <Overlay
    backgroundClass={backgroundClass}
    backgroundUrl={backgroundUrl}
    sharedTheme={sharedTheme}
    theme={theme}
    rendered={rendered}
    innerContainerChildren={innerContainerChildren}
  >
    {children}
  </Overlay>
);

MvpdDirectSignInRedirect.defaultProps = {
  backgroundClass: '',
  backgroundUrl: null,
  children: [],
  innerContainerChildren: () => {},
  rendered: false,
  sharedTheme: {},
  theme: {},
};

MvpdDirectSignInRedirect.propTypes = {
  backgroundClass: PropTypes.string,
  backgroundUrl: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  innerContainerChildren: PropTypes.func,
  rendered: PropTypes.bool,
  sharedTheme: PropTypes.shape({}),
  theme: PropTypes.shape({}),
};

export default MvpdDirectSignInRedirect;
